import new_group_send from '../views/newGroupSend/index.vue'
export default [
  {
    path: '/',
    redirect:'/main',
  },
  {
    path: '/main',
    name:'main',
    component: ()=>import(/* webpackChunkName: "main" */ '../views/Main.vue'),
    redirect:'/main/home',
    children:[
      {
        path:'/main/new_group_send',
        name:'new_group_send',
        component: new_group_send,//() => import(/* webpackChunkName: "new_group_send" */ '../views/newGroupSend/index.vue'),
      },
      {
          path: '/main/home',
          name: 'home',
          component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
          redirect: '/main/home/qunfa',
          children:[
              {
                path: '/main/home/qunfa',
                name: 'qunfa',
                component: () => import(/* webpackChunkName: "qunfa" */ '../views/qunfa/index.vue'),
              },
              {
                path: '/main/home/classManager',
                name: 'classManager',
                component: () => import(/* webpackChunkName: "class-manager" */ '../views/classManager/index.vue'),
                children: [
                  {
                    path:"beginIng/:classCode/:groupClassNo/:schoolId/:groupCode",
                    component: () => import(/* webpackChunkName: "class-manager" */ '../views/classManager/components/classMenu.vue'),
                  },
                  {
                    path:"notBegin/:classCode/:groupClassNo/:schoolId/:groupCode",
                    component: () => import(/* webpackChunkName: "class-manager" */ '../views/classManager/components/classMenu.vue'),
                  },
                  {
                    path:"ended/:classCode/:groupClassNo/:schoolId/:groupCode",
                    component: () => import(/* webpackChunkName: "class-manager" */ '../views/classManager/components/classMenu.vue'),
                  },
                  {
                    path:"empty",
                    component: () => import(/* webpackChunkName: "empty" */ '../views/classManager/components/classEmpty.vue'),
                  }
                ]
              }
            ]
      }
    ],
  },
  {
    path:'/other',
    name:'other',
    component: () => import(/* webpackChunkName: "other" */ '../views/other/Other.vue'),
  },
  
  {
    path:'/login',
    name:'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
  },
  {
    path:'/download',
    name:'download',
    component: () => import(/* webpackChunkName: "download" */ '../views/download/index.vue'),
  },
  {
    path: '/:w+',
    redirect: '/main/home'
  }
]